<template>
    <span> Se Agrego con exito el video a la lista</span>
</template>

<script>
    export default {
        name: "Exito"
    }
</script>

<style scoped>

</style>
